import { NgModule, InjectionToken, inject, APP_INITIALIZER } from '@angular/core';
import { AgeGroupResolver, BandLevelResolver, CountryResolver, EntityGroupResolver, ExtraCriteriaResolver, GenderResolver, GenerationGroupResolver, IKeyResolver, IndustryResolver, JobGradeResolver, KEY_RESOLVER_TOKEN, KeyResolverService, NationalityResolver, NullResolver, PerformanceRatingResolver, SurveyStatusResolver, TenureGroupResolver } from '../../services/key-resolver.service';

export function runKeyResolverInitializer() {
    const resolvers = inject(KEY_RESOLVER_TOKEN); // array of resolvers provided in this lazy module
    const keyResolverService = inject(KeyResolverService);

    resolvers.forEach(r => keyResolverService.registerResolvers([r]));
}

export function registerKeyResolvers(
    keyResolverService: KeyResolverService,
    resolvers: IKeyResolver[] | null
) {
    return () => {
        if (resolvers) {
            keyResolverService.registerResolvers(resolvers);
        }
    };
}

@NgModule({
    providers: [
        { provide: KEY_RESOLVER_TOKEN, useClass: GenderResolver, multi: true },
        { provide: KEY_RESOLVER_TOKEN, useClass: AgeGroupResolver, multi: true },
        { provide: KEY_RESOLVER_TOKEN, useClass: TenureGroupResolver, multi: true },
        { provide: KEY_RESOLVER_TOKEN, useClass: GenerationGroupResolver, multi: true },
        { provide: KEY_RESOLVER_TOKEN, useClass: NationalityResolver, multi: true },
        { provide: KEY_RESOLVER_TOKEN, useClass: SurveyStatusResolver, multi: true },
        { provide: KEY_RESOLVER_TOKEN, useClass: EntityGroupResolver, multi: true },
        { provide: KEY_RESOLVER_TOKEN, useClass: ExtraCriteriaResolver, multi: true },
        { provide: KEY_RESOLVER_TOKEN, useClass: BandLevelResolver, multi: true },
        { provide: KEY_RESOLVER_TOKEN, useClass: JobGradeResolver, multi: true },
        { provide: KEY_RESOLVER_TOKEN, useClass: PerformanceRatingResolver, multi: true },
        { provide: KEY_RESOLVER_TOKEN, useClass: IndustryResolver, multi: true },
        { provide: KEY_RESOLVER_TOKEN, useClass: CountryResolver, multi: true },
        { provide: KEY_RESOLVER_TOKEN, useClass: NullResolver, multi: true }, // fallback
        {
            provide: APP_INITIALIZER,
            useFactory: registerKeyResolvers,
            deps: [KeyResolverService, KEY_RESOLVER_TOKEN],
            multi: true
        },
    ]
})
export class CoreKeyResolverModule { }

